import ethereum from 'decentralized/ethereum.js';
import GetSequences from 'search/GetSequences.js';

export const fetchPeople = async (sequences) => {
    return await getUsersFromResults(sequences);
};

const getUsersFromResults = async (results) => {
    let users = new Set();
    for (let i in results) {
        users.add(results[i].user);
    }
    
    users = Array.from(new Set(users));
    let people = [];
    for (let i in users) {
        let userId = users[i].trim();
        let userName = await ethereum.users.getUserName(userId);
        people.push({
            id: userId,
            userName
        });
    }
    
    return people;
}


